import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ResponsiveViewService } from '../../Services/responsive-view.service';

@Component({
  selector: 'app-responsive-controls',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="responsive-controls-footer">
      <button (click)="setView('mobile')" [class.active]="currentView === 'mobile'" class="view-btn" title="Mobile View">
        <i class="fas fa-mobile-alt"></i>
      </button>
      <button (click)="setView('tablet')" [class.active]="currentView === 'tablet'" class="view-btn" title="Tablet View">
        <i class="fas fa-tablet-alt"></i>
      </button>
      <button (click)="setView('laptop')" [class.active]="currentView === 'laptop'" class="view-btn" title="Laptop View">
        <i class="fas fa-laptop"></i>
      </button>
      <button (click)="setView('desktop')" [class.active]="currentView === 'desktop'" class="view-btn" title="Desktop View">
        <i class="fas fa-desktop"></i>
      </button>
    </div>
  `,
  styles: [`
    .responsive-controls-footer {
      display: flex;
      gap: 8px;
      align-items: center;
      background: #f8f9fa;
      padding: 4px 12px;
      border-top: 1px solid #e9ecef;
      justify-content: center;
    }

    .view-btn {
      background: #fff;
      border: 1px solid #ddd;
      padding: 2px;
      border-radius: 4px;
      cursor: pointer;
      color: #333;
      font-size: 14px;
      transition: all 0.2s ease;
      margin: 0 2px;
      width: 25px;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .view-btn:hover {
      background: #f8f9fa;
      border-color: #007bff;
    }

    .view-btn.active {
      background: #007bff;
      color: white;
      border-color: #007bff;
    }

    .view-btn i {
      font-size: 12px;
    }
  `]
})
export class ResponsiveControlsComponent {
  @Input() currentView: string = 'desktop';
  @Output() viewChange = new EventEmitter<string>();

  constructor(private responsiveViewService: ResponsiveViewService) {}

  setView(view: string) {
    this.currentView = view;
    this.responsiveViewService.setView(view);
    this.viewChange.emit(view);
  }
}